'use client';

import dynamic from 'next/dynamic';
import { styled } from '@linaria/react';

import Spinner from '@/components/Spinner';

function CenteredSpinner() {
  return (
    <SpinnerWrapper style={{ height: 300 }}>
      <Spinner />
    </SpinnerWrapper>
  );
}

const Opposing = dynamic(() => import('./Opposing'), {
  loading: CenteredSpinner,
});

const WithBreak = dynamic(() => import('./WithBreak'), {
  loading: CenteredSpinner,
});

const Asymmetrical = dynamic(() => import('./Asymmetrical'), {
  loading: CenteredSpinner,
});

const SameDirection = dynamic(() => import('./SameDirection'), {
  loading: CenteredSpinner,
});

const Multi = dynamic(() => import('./Multi'), {
  loading: CenteredSpinner,
});

const NegativeIntro = dynamic(() => import('./NegativeIntro'), {
  loading: CenteredSpinner,
});

const Negative = dynamic(() => import('./Negative'), {
  loading: CenteredSpinner,
});

const Mixed = dynamic(() => import('./Mixed'), {
  loading: CenteredSpinner,
});

const Padded = dynamic(() => import('./Padded'), {
  loading: CenteredSpinner,
});
const Gap = dynamic(() => import('./Gap'), {
  loading: CenteredSpinner,
});

const Horizontal = dynamic(() => import('./Horizontal'), {
  loading: CenteredSpinner,
});

const Nested = dynamic(() => import('./Nested'), {
  loading: CenteredSpinner,
});

const StyledComponents = dynamic(() => import('./StyledComponents'), {
  loading: CenteredSpinner,
});

const SpinnerWrapper = styled.div`
  display: grid;
  place-content: center;
`;

const map = {
  Opposing,
  WithBreak,
  Asymmetrical,
  SameDirection,
  Multi,
  NegativeIntro,
  Negative,
  Mixed,
  Padded,
  Gap,
  Horizontal,
  Nested,
  StyledComponents,
};

type Variant = keyof typeof map;

const MarginCollapse = ({ id }: { id: Variant }) => {
  const Component = map[id];

  return <Component />;
};

export default MarginCollapse;
